export const ENVIRONMENT_STAGE = 'STAGE';
export const ENVIRONMENT_DEMO = 'DEMO';
export const ENVIRONMENT_PRODUCTION = 'PRODUCTION';
